import type { TFunction } from "i18next";

export const APPOINTMENT_DRIVER_TYPES = [
  "pickup_and_dropoff",
  "pickup",
  "dropoff",
] as const;

export type AppointmentDriverType = (typeof APPOINTMENT_DRIVER_TYPES)[number];

export const DEFAULT_APPOINTMENT_DRIVER_TYPE: AppointmentDriverType = "pickup_and_dropoff";

export function isAppointmentDriverType(value: unknown): value is AppointmentDriverType {
  return typeof value === "string" && APPOINTMENT_DRIVER_TYPES.includes(value as AppointmentDriverType);
}

export function getEffectiveAppointmentDriverType({
  driverType,
  isTaxiDog,
}: {
  driverType?: string | null;
  isTaxiDog?: boolean | null;
}): AppointmentDriverType | null {
  if (isAppointmentDriverType(driverType)) return driverType;
  if (isTaxiDog) return DEFAULT_APPOINTMENT_DRIVER_TYPE;
  return null;
}

export function getAppointmentDriverLabel(
  driverType: AppointmentDriverType | null,
  t: TFunction<"calendar">,
): string {
  switch (driverType) {
    case "pickup":
      return t("driverTypePickup");
    case "dropoff":
      return t("driverTypeDropoff");
    case "pickup_and_dropoff":
      return t("driverTypePickupAndDropoff");
    default:
      return "";
  }
}

export function shouldFlipAppointmentDriverIcon(driverType: AppointmentDriverType | null): boolean {
  return driverType === "pickup";
}
